export default __webpack_public_path__ + "static/media/right.f8578290.png";